import { AppContext } from "App";
import { createContext, useContext } from "react";
import { MANAGE_EDITOR_PARTIAL } from "utils/permissions";
import BaseInfoView from "./BaseInfoView";
import BOMView from "./BOMView";
import CompanyView from "./CompanyView";
import ComplianceView from "./ComplianceView";
import CostView from "./CostView";
import ImagesView from "./ImagesView";
import OdooInfoView from "./OdooInfoView";
import PackingShipmentView from "./PackingShipmentView";
import ProductionView from "./ProductionView";
import ProductTagsView from "./ProductTagsView";
import RelatedItemsView from "./RelatedItems";
import StateView from "./StateView";

export const ProductContext = createContext({});

const ProductForm = ({ id, product, setProduct }) => {
  const { hasPermission } = useContext(AppContext);

  return (
    <ProductContext.Provider value={{ id, product, setProduct }}>
      {hasPermission() ? (
        <div>
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-8 space-y-8">
              <BaseInfoView />
              <CostView />
              <BOMView />
              <ProductionView />
              <PackingShipmentView />
            </div>

            <div className="space-y-6 col-span-4 flex flex-col">
              <CompanyView />
              <OdooInfoView />
              <ImagesView id={id} />
              <StateView />
              <ComplianceView />
              <RelatedItemsView />
              <ProductTagsView />
            </div>
          </div>
        </div>
      ) : hasPermission(MANAGE_EDITOR_PARTIAL) ? (
        <div className="flex-1 pb-10">
          <div className="card px-6 py-4 relative overflow-auto">
            <PackingShipmentView />
          </div>
        </div>
      ) : null}
    </ProductContext.Provider>
  );
};

export default ProductForm;
